export default __webpack_public_path__ + "static/media/at-infor-logo1.8de8d706.png";